module.exports = __webpack_public_path__ + "0124c643948208698025e5c3abf70976.png";